










(function () {
  if (window.productPackPickerLoaded) return;
  window.productPackPickerLoaded = true;
  function scopeOf(el) {
    return el.closest('.product-buy') || el.closest('.shopify-section') || document;
  }

  function selectOption(option, initializing) {
    var picker = option.closest('[data-pack-picker]');
    if (!picker || (option.dataset.available !== 'true' && !initializing)) return;
    var form = document.getElementById(picker.dataset.form);
    if (!form) return;

    picker.querySelectorAll('[data-pack-option]').forEach(function (el) {
      el.classList.toggle('is-selected', el === option);
      var input = el.querySelector('.pack-picker__input');
      if (input) {
        input.checked = el === option;
        if (picker.dataset.nativeOffers === 'true') input.disabled = el.dataset.available !== 'true';
      }
    });

    var scope = scopeOf(picker);

    if (location.pathname.indexOf('/products/') !== -1) {
      var url = new URL(location.href);
      url.searchParams.set('variant', option.dataset.variantId);
      history.replaceState({}, '', url);
    }
    var variantId = option.getAttribute('data-variant-id');
    var price = option.getAttribute('data-price');
    var offerPrice = option.dataset.offerPrice || price;
    var planInput = picker.querySelector('[data-offer-selling-plan]');
    if (planInput) planInput.value = option.dataset.sellingPlan || '';
    var available = option.getAttribute('data-available') === 'true';

    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value !== variantId) {
      variantInput.value = variantId;

      variantInput.setAttribute('value', variantId);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var submitButton = form.querySelector('.product-form__submit');
    if (submitButton) {
      submitButton.disabled = !available;
      submitButton.toggleAttribute('data-unavailable', !available);

      var labelText = submitButton.querySelector('.main-atc__label__text');
      if (labelText) {
        var label = available
          ? submitButton.getAttribute('data-available-label')
          : submitButton.getAttribute('data-sold-out-label');
        if (label) labelText.textContent = label;
      }

      var priceWrap = submitButton.querySelector('.main-atc-price');
      if (priceWrap) priceWrap.classList.toggle('hidden', !available);
    }

    scope.querySelectorAll('[class*="main-atc-price-span-"]').forEach(function (span) {
      span.textContent = offerPrice;
    });

    scope.querySelectorAll('.sticky-atc-btn').forEach(function (button) {
      if (button.dataset.form === form.getAttribute('id')) button.disabled = !available;
    });
    scope.querySelectorAll('.one-time-btn').forEach(function (button) {
      if (button.dataset.form === form.getAttribute('id') && button.dataset.labelTemplate) {
        button.disabled = !available;
        if (picker.dataset.nativeOffers === 'true') {
          button.closest('.one-time').hidden = !option.dataset.sellingPlan || option.dataset.requiresSellingPlan === 'true';
        }
        button.textContent = button.dataset.labelTemplate.replace('[price]', price);
      }
    });
  }

  function initializeOffers(root) {
    root.querySelectorAll('[data-pack-picker]').forEach(function (picker) {
      var selected = picker.querySelector('.pack-picker__input:checked');
      var option = selected && selected.closest('[data-pack-option]');
      if (option) selectOption(option, true);
    });
  }

  async function prepareSubscriptionGifts(data, option) {
    var variantId = option.dataset.variantId;
    var planId = option.dataset.sellingPlan;
    var parentIndex = null;
    var nextIndex = 0;
    data.forEach(function (value, name) {
      var match = name.match(/^items\[(\d+)\]\[id\]$/);
      if (!match) return;
      var index = Number(match[1]);
      nextIndex = Math.max(nextIndex, index + 1);
      if (value === variantId && data.get('items[' + index + '][selling_plan]') === planId) parentIndex = index;
    });
    var flatParent = data.get('id') === variantId && data.get('selling_plan') === planId;
    if (parentIndex === null && !flatParent) return;

    var response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to check the welcome gifts in your cart.');
    var cart = await response.json();
    var parents = cart.items.filter(function (item) {
      return String(item.variant_id) === variantId && item.selling_plan_allocation &&
        String(item.selling_plan_allocation.selling_plan.id) === planId;
    });


    var sameVariantRequests = flatParent ? 1 : 0;
    data.forEach(function (value, name) {
      if (/^items\[\d+\]\[id\]$/.test(name) && value === variantId) sameVariantRequests++;
    });
    var prefix = parentIndex === null ? 'properties[' : 'items[' + parentIndex + '][properties][';
    var properties = {};
    var comparable = true;
    data.forEach(function (value, name) {
      if (name.indexOf(prefix) !== 0 || name.slice(-1) !== ']') return;
      var key = name.slice(prefix.length, -1);
      if (typeof value !== 'string' || Object.prototype.hasOwnProperty.call(properties, key)) comparable = false;
      properties[key] = value;
    });
    var matchingProperties = function (item) {
      var existing = item.properties || {};
      var keys = Object.keys(properties);
      return comparable && keys.length === Object.keys(existing).length &&
        keys.every(function (key) { return properties[key] === existing[key]; });
    };
    if (sameVariantRequests > 1 || parents.length > 1 || (parents.length && !matchingProperties(parents[0]))) {
      return { variantId: variantId, planId: planId, giftIds: option.dataset.subscriptionGifts.split(',') };
    }
    var parentKeys = parents.map(function (item) { return item.key; });
    var missing = option.dataset.subscriptionGifts.split(',').filter(function (id) {
      return !cart.items.some(function (item) {
        return String(item.variant_id) === id && item.parent_relationship &&
          parentKeys.indexOf(item.parent_relationship.parent_key) !== -1;
      });
    });
    if (!missing.length) return;

    if (parentIndex === null) {
      parentIndex = nextIndex++;
      Array.from(data.entries()).forEach(function (entry) {
        var name = entry[0];
        if (['id', 'quantity', 'selling_plan'].indexOf(name) !== -1 || name.indexOf('properties[') === 0) {
          var nestedName = name.indexOf('properties[') === 0 ? '[properties]' + name.slice(10) : '[' + name + ']';
          data.append('items[' + parentIndex + ']' + nestedName, entry[1]);
          data.delete(name);
        }
      });
      if (!data.has('items[' + parentIndex + '][quantity]')) data.set('items[' + parentIndex + '][quantity]', '1');
    }
    missing.forEach(function (id) {
      var prefix = 'items[' + nextIndex++ + ']';
      data.append(prefix + '[id]', id);
      data.append(prefix + '[quantity]', '1');
      data.append(prefix + '[properties][_subscription_welcome_gift]', 'true');
      data.append(prefix + (parents.length ? '[parent_line_key]' : '[parent_id]'), parents.length ? parents[0].key : variantId);
    });
  }

  async function attachDeferredSubscriptionGifts(intents, response, formData) {
    var addedItems = Array.isArray(response.items) ? response.items : [response];
    var parents = [];
    intents.forEach(function (intent) {
      var eligible = addedItems.filter(function (item) {
        return String(item.variant_id || item.id) === intent.variantId && item.selling_plan_allocation &&
          String(item.selling_plan_allocation.selling_plan.id) === intent.planId;
      });
      if (!eligible.length || eligible.some(function (item) { return !item.key; })) {
        throw new Error('Your subscription is in the cart. Its welcome gifts could not be linked safely. Please review your cart before checkout.');
      }
      eligible.forEach(function (item) { parents.push({ key: item.key, giftIds: intent.giftIds }); });
    });
    var cartResponse = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Your subscription is in the cart. Please review your welcome gifts before checkout.');
    var cart = await cartResponse.json();
    var items = [];
    var seen = new Set();
    parents.forEach(function (parent) {
      parent.giftIds.forEach(function (giftId) {
        var key = parent.key + '|' + giftId;
        var present = cart.items.some(function (item) {
          return String(item.variant_id) === giftId && item.parent_relationship && item.parent_relationship.parent_key === parent.key;
        });
        if (present || seen.has(key)) return;
        seen.add(key);
        items.push({ id: Number(giftId), quantity: 1, parent_line_key: parent.key, properties: { _subscription_welcome_gift: 'true' } });
      });
    });
    if (!items.length) return;
    var body = { items: items };
    if (formData.get('sections')) body.sections = formData.get('sections');
    if (formData.get('sections_url')) body.sections_url = formData.get('sections_url');
    var giftResponse = await fetch(window.routes.cart_add_url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    });
    var result = await giftResponse.json();
    if (!giftResponse.ok || result.status) throw new Error('Your subscription is in the cart. The welcome gifts could not be added. Please review your cart before checkout.');
    if (result.sections) response.sections = Object.assign(response.sections || {}, result.sections);
    else delete response.sections;
  }

  document.addEventListener('product-form:prepare', function (event) {
    var picker = Array.from(document.querySelectorAll('[data-pack-picker]')).find(function (node) {
      return node.dataset.form === event.target.getAttribute('id');
    });
    var option = picker && picker.querySelector('[data-subscription-gifts]');
    if (option) event.detail.tasks.push(prepareSubscriptionGifts(event.detail.formData, option).then(function (intent) {
      if (!intent) return;
      if (!event.detail.deferredGifts) event.detail.deferredGifts = [];
      event.detail.deferredGifts.push(intent);
    }));
  });

  document.addEventListener('product-form:added', function (event) {
    var intents = event.detail.deferredGifts;
    if (intents && intents.length) event.detail.tasks.push(attachDeferredSubscriptionGifts(intents, event.detail.response, event.detail.formData));
  });




  document.addEventListener('product-form:added', function (event) {
    if (!/\/products\/fbg\/?$/.test(location.pathname)) return;
    try {
      var response = event.detail.response;
      var formData = event.detail.formData;
      var requested = [];
      formData.forEach(function (value, name) {
        var match = name.match(/^items\[(\d+)\]\[id\]$/);
        if (name !== 'id' && !match) return;
        var prefix = match ? 'items[' + match[1] + ']' : '';
        var field = function (key) { return formData.get(prefix ? prefix + '[' + key + ']' : key); };
        requested.push({ id: String(value), quantity: Number(field('quantity') || 1), plan: String(field('selling_plan') || '') });
      });
      var items = Array.isArray(response.items) ? response.items : [response];
      if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
      Shopify.analytics.publish('vira_cart_added', {
        currency: window.Shopify.currency && Shopify.currency.active,
        items: items.map(function (item) {
          var gift = item.properties && item.properties._subscription_welcome_gift === 'true' &&
            !!item.parent_relationship;
          var id = String(item.variant_id || item.id);
          var plan = String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || '');
          var request = requested.find(function (entry) { return entry.id === id && entry.plan === plan; });
          if (!request) return null;
          var quantity = request.quantity;
          requested.splice(requested.indexOf(request), 1);
          var unitPrice = item.final_price == null ? item.price : item.final_price;
          return {
            id: id,
            quantity: quantity,
            line_price: unitPrice * quantity,
            unit_price: unitPrice,
            automatic_gift: !!gift
          };
        }).filter(Boolean)
      });
    } catch (error) {                                                                  }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var picker = Array.from(document.querySelectorAll('[data-pack-picker]')).find(function (node) {
      return node.dataset.form === form.getAttribute('id');
    });
    if (!picker || picker.dataset.nativeOffers !== 'true') return;
    var selected = picker.querySelector('.pack-picker__input:checked');
    var option = selected && selected.closest('[data-pack-option]');
    if (!option || option.dataset.available !== 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var oneTime = event.submitter && event.submitter.hasAttribute('data-offer-checkout');
    if (oneTime && option.dataset.requiresSellingPlan === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    picker.querySelector('[data-offer-selling-plan]').value = oneTime ? '' : (option.dataset.sellingPlan || '');


    form.dataset.skipCartButton = oneTime ? 'true' : 'false';
  }, true);

  // "Buy once" goes straight to checkout, so it must buy exactly the selected
  // offer. Lines of this product (any variant or plan) and the welcome gifts
  // nested under them are removed first; other products stay in the cart.
  async function updateCartLines(updates) {
    var response = await fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    var cart = await response.json();
    if (!response.ok || cart.status) throw new Error('Unable to prepare checkout.');
    return cart;
  }

  async function clearProductForBuyOnce(variantIds) {
    var response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to prepare checkout.');
    var cart = await response.json();
    var removedKeys = [];
    var updates = {};
    cart.items.forEach(function (item) {
      if (variantIds.indexOf(String(item.variant_id)) === -1) return;
      removedKeys.push(item.key);
      updates[item.key] = 0;
    });
    if (!removedKeys.length) return;
    var isOrphanedGift = function (item) {
      return item.parent_relationship && removedKeys.indexOf(item.parent_relationship.parent_key) !== -1;
    };
    // Shopify removes nested lines with their parent; remove any that remain.
    cart.items.forEach(function (item) { if (isOrphanedGift(item)) updates[item.key] = 0; });
    cart = await updateCartLines(updates);
    var leftovers = {};
    cart.items.forEach(function (item) {
      if (isOrphanedGift(item) || removedKeys.indexOf(item.key) !== -1) leftovers[item.key] = 0;
    });
    if (Object.keys(leftovers).length) await updateCartLines(leftovers);
  }

  document.addEventListener('product-form:prepare', function (event) {
    var form = event.target;
    if (!form.dataset || form.dataset.skipCartButton !== 'true') return;
    // The submit handler has already read the flag; a later programmatic submit must not inherit it.
    form.dataset.skipCartButton = 'false';
    var picker = Array.from(document.querySelectorAll('[data-pack-picker]')).find(function (node) {
      return node.dataset.form === form.getAttribute('id');
    });
    if (!picker || picker.dataset.nativeOffers !== 'true') return;
    var variantIds = Array.from(picker.querySelectorAll('[data-pack-option]')).map(function (option) {
      return String(option.dataset.variantId);
    });
    event.detail.tasks.push(clearProductForBuyOnce(variantIds));
  });
  initializeOffers(document);
  document.addEventListener('shopify:section:load', function (event) { initializeOffers(event.target); });

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-pack-option]');
    if (!option || option.classList.contains('is-selected')) return;
    selectOption(option);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var option = event.target.closest('[data-pack-option]');
    if (!option || option.classList.contains('is-selected')) return;
    event.preventDefault();
    selectOption(option);
  });





  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('pack-picker__input')) return;
    var option = input.closest('[data-pack-option]');
    if (!option || option.classList.contains('is-selected')) return;
    selectOption(option);
  });
})();
